function HeroTopHeading({ children }) {
    return (
        <p className="text-secondary uppercase text-lg leading-8 font-semibold">
            {children}
        </p>
    )
}

export default HeroTopHeading
